<template>
  <div v-if="value">
    <!-- 반품 정보 -->
    <table class="delivery-refund-info" style="margin-top:12px">
      <tbody>
      <tr>
        <td class="order-info-title">환불 금액</td>
        <td>
          <div v-if="value.is_first_dp_refund">초기 배송비: {{ value.delivery_cost | currency }}</div>
          <div>반품 배송비: -{{ value.substraction_price | currency }}</div>
          <div>포인트: -{{ value.point | currency }}</div>
          <div>쿠폰할인: -{{ value.coupon_price | currency }}</div>
          <div>상품 금액: {{ refundTotalPrice | currency }}</div>
          <div>계: {{ value.refund_price | currency }}</div>
        </td>
      </tr>
      <tr>
        <td class="order-info-title">환불 수단</td>
        <td>
          <span v-if="value.refund_method===0">
            현금 (환불 계좌:
          {{ value.refund_info.bank }}
          {{ value.refund_info.account_num }}
          {{ value.refund_info.name }})
          </span>
          <span v-else>카드</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "refund-info",
    props: {
      refund_id: {
        type: Number,
        required: false
      },
      order: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        value: undefined
      }
    },
    created () {
      this.getData();
    },
    computed: {
      refundTotalPrice () {
        let total = 0;
        this.value.order_product.forEach(item => {
          total += item['total_price'];
        });
        return total;
      },
    },
    methods: {
      getData () {
        this.$axios.get(this.getUrl(`delivery/order/${this.$route.query.id}/refund/${this.refund_id}`)).then(res => {
          this.value = res.data;
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-refund-info
    width 100%

  .delivery-refund-info td
    text-align left
    border 1px solid #e0d9d9
    padding 10px
    vertical-align middle !important

  .delivery-refund-info
    background-color #eee
</style>
